import { gql } from '@apollo/client'

export const Query = gql`
  query customFieldValues(
    $companyId: ID!,
    $filters: CustomFieldValueFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    customFieldValues(
      companyId: $companyId,
      filters: $filters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        customField {
          id
          name
          enabled
          fieldType
          options { id value }
        }
        value
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
